import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { whatsNewCountKey } from '@services/useWhatsNewCountQuery';

import { whatsNewListKey } from './useWhatsNewListInfiniteQuery';

const whatsNewMarkViewedFn = (data: { whatsNewIds: number[] }) =>
  apiClient.post(`${APP_API_URL_V2}customer-dashboard-v2/whats-new/set-viewed`, data);

export const useWhatsNewMarkViewedMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: whatsNewMarkViewedFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsNewCountKey() });
      queryClient.invalidateQueries({ queryKey: [whatsNewListKey({})[0]] });
    },
  });
};
